"use client";

import { cn } from "@/lib/utils";
import { useSearchStore } from "@/stores/searchStore";
import SearchIcon from "@app/_icons/SearchIcon/SearchIcon";
import MobileMenu from "@components/MobileMenu/MobileMenu";
import { useHeaderContext } from "@context/headerContext";
import type { ReactNode } from "react";
import { useMemo } from "react";
import Search from "../search";
import Actions from "./Actions";
import Menu from "./Menu";

export default function Content({ children }: { children: ReactNode }) {
  const { dictionary, scrollDirection, hasScrolled } = useHeaderContext();
  const mobileSearchOpen = useSearchStore((state) => state.mobileSearchOpen);
  const setMobileSearchOpen = useSearchStore(
    (state) => state.setMobileSearchOpen,
  );
  const hideSearch = useMemo(
    () => hasScrolled && scrollDirection === "down" && mobileSearchOpen,
    [hasScrolled, scrollDirection, mobileSearchOpen],
  );

  return (
    <div className="lg:pointer-events-none lg:child:pointer-events-auto">
      <div className="relative z-10 bg-white">
        <div className="container relative grid h-12 w-full grid-cols-[4rem,auto,4rem] items-stretch justify-between bg-white px-3 lg:z-40 lg:h-14 lg:grid-cols-[1fr,auto,1fr]">
          <div className="flex items-center gap-1">
            <MobileMenu />
            <button
              type="button"
              className={cn(
                "p-1 transition-opacity duration-100 lg:hidden",
                !hideSearch && "pointer-events-none opacity-0",
              )}
              onClick={() => {
                setMobileSearchOpen(!mobileSearchOpen);
              }}
            >
              <SearchIcon className="size-4" />
              <span className="sr-only">{dictionary?.search}</span>
            </button>
            <Search
              searchInputId="search-input-desktop"
              classNames={{
                root: "max-lg:hidden lg:max-w-[220px]",
                input: "border-grey-150 focus:border-grey-200",
              }}
              dictionary={dictionary}
            />
          </div>
          {children}
          <div className="flex items-center justify-end">
            <Actions />
          </div>
        </div>
      </div>
      <Menu />
      <Search
        searchInputId="search-input-mobile"
        classNames={{
          root: cn(
            "transition-transform duration-100 lg:hidden",
            hideSearch && "-translate-y-full",
          ),
          input:
            "h-10 pl-11 border-t border-b border-color-grey-150 border-x-0 border-grey-150 placeholder:text-sm",
          icon: "left-4",
        }}
        dictionary={dictionary}
      />
    </div>
  );
}
